import { ComponentProps } from 'react';
import { ComputerTower } from '@phosphor-icons/react';
import {
  PlanCardListItem,
  useOfferContext,
  useProviderContext,
} from '@updater/ui-widgets';
import type { TvInternetOffer } from '@updater/consumer-graph';
import { getEquipmentRentalText } from 'utils/get-equipment-rental-text';

export const PlanCardListItemEquipmentRental: React.FC<
  Partial<ComponentProps<typeof PlanCardListItem>>
> = ({ ...props }) => {
  const { name, products } = useOfferContext() as TvInternetOffer;
  const { code: providerCode } = useProviderContext();

  if (!name || !providerCode) {
    return null;
  }

  const isTvBundled = Boolean(products?.tv);
  const equipmentRentalText = getEquipmentRentalText(
    name,
    providerCode,
    isTvBundled
  );

  if (!equipmentRentalText) {
    return null;
  }

  return (
    <PlanCardListItem
      icon={<ComputerTower weight="light" size={22} />}
      text={equipmentRentalText}
      {...props}
    />
  );
};
